import React from "react";

const IneligibleSkipContent = (props) => {
  const skipDenialReasons = props.authPayment.skipDenialReasons;

  const filteredReasons = skipDenialReasons.filter((reason, index) => {
    return !reason.includes("888.267.7200");
  })

  const reasons = filteredReasons.map((reason, index) => {
    return (
      <li key={index} className="f14">
        {reason}
      </li>
    );
  });

  return (
    <div>
      <h5 className="text-center bold mb-3">Ineligible for Skip a Pay</h5>
      <ul className="f14 p-0" style={{ listStyle: "none" }}>
        {reasons}
      </ul>
        <div className="f14 mb-3">
          Unable to process Skip A Pay. If you have any questions, call us at 888.267.7200.
          </div>
    </div>
  );
};

export default IneligibleSkipContent;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/modal/ineligible-skip-content.component.js